import { Link } from 'react-router-dom';
import {
  Checkbox,
  FormLabel,
  FormControl,
  FormControlLabel,
  MenuItem,
  RadioGroup,
  Select,
  styled,
} from '@nextiva/next-ui-components';
import sassVars from 'styles/application/_base/_variables.scss';
import { pxToRem } from 'utils/pxToRemConverter';

export const Container = styled('div')`
  padding: 0 0 100px;
`;

export const FormControlComponent = styled(FormControl)`
  margin-bottom: 24px;
`;

export const Header = styled('div')`
  display: flex;
  align-items: center;
  height: 64px;
  font-size: ${pxToRem('20px')};
  font-weight: 600;
  letter-spacing: 0.15;
`;

export const Title = styled('div')`
  margin: 24px 0;
  font-size: ${pxToRem('16px')};
  font-weight: 700;
`;

export const Divider = styled('div')`
  border-bottom: 1px solid ${sassVars.dividerColor};
`;

export const RadioBtn = styled(RadioGroup)`
  flex-direction: row;
  .MuiRadio-root {
    color: ${sassVars.secondaryColor};
    border-radius: 50%;
  }
  .MuiRadio-colorSecondary.Mui-checked {
    color: ${sassVars.primaryBlue};
  }
  .MuiIconButton-root {
    padding: 9px;
  }
  .MuiIconButton-colorSecondary:hover {
    background-color: ${sassVars.primaryColorHover};
  }
  .MuiTypography-body1 {
    font-size: ${pxToRem('14px')};
  }
`;

export const FormLabelCss = styled(FormLabel)`
  &.MuiFormLabel-root {
    margin: 0 0 8px;
  }
`;

export const SelectComponent = styled(Select)`
  width: 260px;
  margin: 0 24px 0 0;
  & .MuiOutlinedInput-input {
    padding: 10.5px 32px 10.5px 14px;
    color: ${sassVars.menuLinkActiveColor};
    font-family: Lato, sans-serif;
    font-size: 16px;
    font-weight: 400;
  }
  & .MuiOutlinedInput-notchedOutline {
    border-color: ${sassVars.secondaryColor};
  }
  &.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${sassVars.secondaryColor};
  }
  &.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${sassVars.secondaryColor};
    border-width: 1px;
  }
  & .MuiSelect-icon {
    color: ${sassVars.secondaryColor};
  }
`;

export const SelectOptions = styled(MenuItem)`
  &.MuiMenuItem-root {
    margin-bottom: 2px;
    color: ${sassVars.menuLinkActiveColor};
    font-family: Lato, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 19px;
    &:hover {
      background-color: ${sassVars.menuItemBg};
    }
  }
`;

export const Label = styled(FormControlLabel)`
  margin: 9px 16px 0px 0px !important;
  .MuiTypography-body1 {
    font-family: Lato, sans-serif;
    font-size: ${pxToRem('14px')};
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.21px;
  }
`;

export const CheckboxComponent = styled(Checkbox)`
  &.MuiCheckbox-root {
    color: ${sassVars.secondaryColor};
  }
  &.MuiCheckbox-root.Mui-checked {
    color: ${sassVars.primaryBlue};
  }
  &.MuiCheckbox-colorSecondary.Mui-checked:hover {
    background-color: ${sassVars.secondaryColorHover};
  }
  &.MuiButtonBase-root {
    padding: 9px 9px 9px 0px;
  }
  &.MuiIconButton-colorSecondary:hover {
    background-color: ${sassVars.secondaryColorHover};
  }
  &.MuiTypography-body1 {
    font-size: ${pxToRem('14px')};
  }
`;

export const Here = styled(Link)`
  color: #0000ee !important;
  text-decoration: underline;
`;
